import { styled } from 'styled-components';

export const StyledSharingButtonContainer = styled.div`
    width: fit-content;
`;
